import { Radio as FuseRadio } from '@tvg/fuse/radio';
import React from 'react';
import styles from './ProductsPerPage.module.css';

export interface RadioProps {
  position: string;
  value: number;
  label: string;
  checked: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

function Radio({ position, label, ...props }: RadioProps) {
  const id = `products-per-page-${position}-${label}`;
  const radioName = `products-per-page-${position}`;

  return (
    <FuseRadio
      analyticsId={id}
      dataTestId={id}
      radioLabel={label}
      radioName={radioName}
      srLabel="products per page"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      className={styles.productsPerPage__radio}
    />
  );
}

export default React.memo(Radio);
